export var PriorityLevel;
(function (PriorityLevel) {
    PriorityLevel["Blocked"] = "Blocked";
    PriorityLevel["Major"] = "Major";
    PriorityLevel["Minor"] = "Minor";
})(PriorityLevel || (PriorityLevel = {}));
export var PriorityLevelMessages;
(function (PriorityLevelMessages) {
    PriorityLevelMessages["Blocked"] = "This issue prevents me from completing my work or blocks the use of the product.";
    PriorityLevelMessages["Major"] = "This issue greatly impacts my work on a project but does not block me.";
    PriorityLevelMessages["Minor"] = "This issue does not hinder my ability to complete my work or use the product effectively.";
})(PriorityLevelMessages || (PriorityLevelMessages = {}));
